import * as yup from 'yup';

const mailPermissionSchema = yup.object().shape({
  title: yup.string().ensure().required(),
  label: yup.string().ensure().required(),
});

export default mailPermissionSchema;
